import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { TinyCart } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { ConverterService } from '../../../../core/util';
import { TINY_CART_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class TinyCartConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  load(userId: string): Observable<TinyCart[]> {
    return this.httpClient
      .get<Occ.TinyCartList>(this.occEndpointsService.buildUrl('tinyCarts', { urlParams: { userId: userId } }))
      .pipe(pluck('tinyCarts'), this.converterService.pipeableMany(TINY_CART_NORMALIZER));
  }

  loadSpecific(userId: string, cartId: string): Observable<TinyCart> {
    return this.httpClient
      .get<Occ.TinyCart>(
        this.occEndpointsService.buildUrl('tinyCart', {
          urlParams: {
            userId: userId,
            cartCodeOrType: cartId,
          },
        })
      )
      .pipe(this.converterService.pipeable(TINY_CART_NORMALIZER));
  }
}
